import React from 'react'
import { constants, formatPrice } from 'helpers'
import { useFt } from 'hooks'

import { useProductGiftPromo } from 'modules/products'
import { useCartContext } from 'modules/cart'

import { Progress, Text } from 'components/dataDisplay'
import { Bone } from 'components/layout'

import messages from './messages'


type GiftWithSpendThresholdProgressProps = {
  className?: string
}

const getSpendThresholdMessage = (messagesData: any, remain: number): Intl.Message => {
  if (remain === 0) {
    return messagesData.earned
  }

  if (remain > 0) {
    return {
      ...messagesData.remain,
      values: {
        remain: formatPrice(remain),

      },
    }
  }

  return null
}

const GiftWithSpendThresholdProgress: React.FunctionComponent<GiftWithSpendThresholdProgressProps> = (props) => {
  const { className } = props
  const { cart } = useCartContext()

  const isHolidayFathersDayEnabled = useFt(constants.features.holidayFathersDay)

  const { subTotal, isFetching } = useProductGiftPromo()

  const ecommercePromoProgress = cart?.purchaseProgress?.ecommercePromoProgress?.[0]

  if (!ecommercePromoProgress) {
    return null
  }

  const { freeEcommercePromoGoal, freeEcommercePromoProgress, freeEcommercePromoRemain } = ecommercePromoProgress

  const messagesData = isHolidayFathersDayEnabled ? messages.fathersDay : messages.default

  const message = getSpendThresholdMessage(messagesData, freeEcommercePromoRemain)
  const progress = freeEcommercePromoRemain ? (freeEcommercePromoProgress / freeEcommercePromoGoal) * 100 : 100

  if (!message) {
    return null
  }

  if (isFetching) {
    return (
      <Bone
        className={className}
        pw={100}
        h={148}
      />
    )
  }

  if (!subTotal) {
    return null
  }

  return (
    <Progress
      className={className}
      message={message}
      progress={progress}
      textStyle="p2"
      data-testid="giftWithSpentThreshold"
    >
      <Text
        className="mb-24 mt-8"
        message={{
          ...messagesData.description,
          values: {
            subTotal: formatPrice(subTotal.amountCents, { removeZeroCents: true }),
          },
        }}
        style="p5"
      />
    </Progress>
  )
}

export default GiftWithSpendThresholdProgress
